<template>
    <a class="scroll-to-top"></a>
</template>

<script>
    export default {
        name:"ScrollTopBtn",
    }
</script>